module.exports = __webpack_public_path__ + "img/744.47fd11bb.jpg";